// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    savedContacts: {
        id: 'text-control.saved-contacts',
        defaultMessage: 'Text control successfully saved'
    },
    errorSavingContacts: {
        id: 'text-control.saved-contacts-error',
        defaultMessage: 'There was a problem saving your text control settings. Please try again.'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/text-control/intl.js